(function () {
  const root = document.querySelector('.size-chart')
  if (!root) return
  const value = root.querySelector('[data-sc-zoom-val]')
  const buttons = root.querySelectorAll('[data-sc-zoom]')
  if (!value || !buttons.length) return

  const steps = [16, 20, 24, 28, 32]
  let i = 0

  function applyZoom () {
    root.style.setProperty('--sc-zoom', steps[i] + 'px')
    value.textContent = Math.round((steps[i] / steps[0]) * 100) + '%'
    buttons.forEach(function (b) {
      b.disabled = b.getAttribute('data-sc-zoom') === '-' ? i === 0 : i === steps.length - 1
    })
  }

  buttons.forEach(function (b) {
    b.addEventListener('click', function () {
      i =
        b.getAttribute('data-sc-zoom') === '+'
          ? Math.min(i + 1, steps.length - 1)
          : Math.max(i - 1, 0)
      applyZoom()
    })
  })

  applyZoom()
})()
